package uz.ferro.erp

import mui.system.Breakpoint
import mui.system.Theme
import mui.system.useMediaQuery
import mui.system.useTheme
import react.Context
import react.FC
import react.Props
import react.create
import react.createContext
import react.dom.client.createRoot
import react.router.Outlet
import react.router.RouterProvider
import remix.run.router.Router
import uz.ferro.erp.api.BaseUrl
import uz.ferro.erp.locale.Language
import uz.ferro.erp.locale.LanguageManager
import uz.ferro.erp.locale.LocaleDict
import uz.ferro.erp.navigator.AppNavigator
import uz.ferro.erp.navigator.Navigator
import web.dom.document

const val BASE_FILE_URL = BaseUrl.HOST

fun main() {
    val root = document.createElement(web.html.HTML.div)
        .also { document.body.appendChild(it) }

    createRoot(root)
        .render(ReactRouterDomApp.create())
}

abstract class ApplicationContext {

    // <576px
    abstract val isXs: Boolean

    // 	≥576px
    abstract val isSm: Boolean

    //  ≥768px
    abstract val isMd: Boolean

    //  ≥992px
    abstract val isLg: Boolean

    //  ≥1200px
    abstract val isXl: Boolean

    abstract fun setLanguage(language: Language)
}

val AppContext: Context<ApplicationContext> = createContext(object : ApplicationContext() {
    override val isXs: Boolean = false
    override val isSm: Boolean = true
    override val isMd: Boolean = true
    override val isLg: Boolean = true
    override val isXl: Boolean = true

    override fun setLanguage(language: Language) {}
})

val LocaleContext: Context<LocaleDict> = createContext(LocaleDict)
val NavigationContext: Context<Navigator> = createContext(AppNavigator(getRouterProvider()))

val Root = FC<Props> {
    Outlet()
}

fun navigateToLink(link: String, options: Any? = null) {
    appRouter.navigate(link, options ?: "")
}

class RouterProvider {
    fun getRouter(): Router = appRouter
}

private fun getRouterProvider() = RouterProvider()

val ReactRouterDomApp = FC<Props> {
    val theme: Theme = useTheme()

    val appContext = object : ApplicationContext() {
        override val isXs: Boolean = useMediaQuery(theme.breakpoints.up(Breakpoint.xs))
        override val isSm: Boolean = useMediaQuery(theme.breakpoints.up(Breakpoint.sm))
        override val isMd: Boolean = useMediaQuery(theme.breakpoints.up(Breakpoint.md))
        override val isLg: Boolean = useMediaQuery(theme.breakpoints.up(Breakpoint.lg))
        override val isXl: Boolean = useMediaQuery(theme.breakpoints.up(Breakpoint.xl))

        override fun setLanguage(language: Language) {
            LanguageManager.currentLanguage = language
        }
    }

    AppContext(appContext) {
        LocaleContext(LocaleDict) {
            NavigationContext(AppNavigator(getRouterProvider())) {
                RouterProvider {
                    router = appRouter
                }
            }
        }
    }
}
